export default __webpack_public_path__ + "static/media/calenderIcon.9dbfead5.svg";